import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../booking/api";
import { useAuth } from "../../booking/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/api/auth/login", { email, password });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#15262d] px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-xl p-8 shadow-2xl">
        <img src="/logo-teal.png" alt="Tribe" className="h-10 mx-auto mb-2" />
        <h1 className="text-center text-lg font-medium mb-1">TAF Experience Admin</h1>
        <p className="text-center text-sm text-muted-foreground mb-6">Sign in to the back-office</p>
        <div className="space-y-4">
          <Input data-testid="admin-login-email" type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
          <Input data-testid="admin-login-password" type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" className="w-full" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </div>
      </form>
    </div>
  );
}
